import { Box } from '@material-ui/core';
import { openWhatsapp } from 'utils/handleSendMessageWhatsapp';
import Whatsapp from '../../../assets/svg/whatsapp_v2.svg';
import { PrimaryButton } from '../../../component/customize_style_component/styled_button';

function ContactUs(props) {
    const { user } = props;
    return (
        <div
            onClick={() =>
                openWhatsapp('Hello Taffi !\n\n\n', {
                    userId: user?.id,
                    userType: user?.userType,
                    reason: 'general_question',
                })
            }
        >
            <Box p={3}>
                <PrimaryButton padding="10px 20px">
                    <img src={Whatsapp} alt="icon" style={{ marginRight: 10 }} /> Open Whatsapp
                </PrimaryButton>
            </Box>
        </div>
    );
}

export default ContactUs;
